import React, {Component} from 'react';
import {Header} from '../Header';
import {Footer} from '../Footer';
import {Helmet} from "react-helmet";

export class AccessibilityPL extends Component {
    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        return (
            <div>
                <Helmet>
                    <title>Deklaracja dostępności - CamAPS FX</title>
                    <meta name="title" content="Deklaracja dostępności"/>
                    <meta name="description"
                          content="CamDiab zobowiązuje się do ułatwiania i poprawy dostępności oraz użyteczności swoich produktów cyfrowych dla wszystkich osób, w tym osób z niepełnosprawnościami"/>
                    <meta property="og:locale" content="pl"/>
                    <meta name="keywords" content="deklaracja dostępności"/>
                </Helmet>
                <Header props={this.props}/>
                <section className="inner-banner">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-12 col-sm-10">
                                <h1>Deklaracja dostępności</h1>
                                <h3>Wersja z dnia 11 września 2026 r.</h3>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="inner-page-content">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 col-sm-12">
                                <p>
                                    CamDiab zobowiązuje się do ułatwiania i poprawy dostępności oraz użyteczności swoich produktów cyfrowych dla wszystkich osób, w tym osób z niepełnosprawnościami.
                                </p>
                                <h2>
                                    Status zgodności
                                </h2>
                                <p>
                                    CamDiab dąży do osiągnięcia zgodności z Wytycznymi dotyczącymi dostępności treści internetowych (WCAG) w wersji 2.2 na poziomie AA (WCAG 2.2 AA). Te uznawane na całym świecie wytyczne pomagają zwiększyć dostępność treści internetowych dla wszystkich.
                                </p>
                                <h2>
                                    Dodatkowe działania wspierające dostępność
                                </h2>
                                <p>
                                    CamDiab podejmuje między innymi następujące dodatkowe działania, aby ułatwić korzystanie z naszych treści cyfrowych:
                                </p>
                                <ul>
                                    <li>Zapewnianie naszym pracownikom ciągłych szkoleń z zakresu dostępności</li>
                                    <li>Stosowanie formalnych metod zapewniania jakości dostępności poprzez oceny przeprowadzane przez podmioty zewnętrzne</li>
                                    <li>Wyznaczanie jasnych celów i zakresów odpowiedzialności dotyczących dostępności</li>
                                </ul>
                                <h2>
                                    Opinie
                                </h2>
                                <p>
                                    Zachęcamy do przekazywania uwag dotyczących sposobów ulepszania naszych produktów cyfrowych dla użytkowników z niepełnosprawnościami. Jeśli masz trudności z wyświetlaniem naszych treści lub poruszaniem się po nich albo zauważysz treść, funkcję lub element funkcjonalny, który Twoim zdaniem nie jest w pełni dostępny dla osób z niepełnosprawnościami, skontaktuj się z nami za pomocą naszego adresu e-mail pomocy technicznej: <a href="mailto:support@camdiab.com">support@camdiab.com</a>
                                </p>
                                <p>
                                    Poważnie traktujemy Twoje uwagi i będziemy je uwzględniać podczas oceny sposobów zaspokajania potrzeb wszystkich naszych klientów oraz naszych ogólnych zasad dotyczących dostępności. Ponadto, mimo że nie mamy kontroli nad treściami dostarczanymi przez zewnętrznych dostawców, zdecydowanie zachęcamy ich do zapewniania treści, które są dostępne i przyjazne dla użytkownika.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
                <Footer props={this.props}/>
            </div>
        );
    }
}
